export const GET_CITIES_SENDING_REQUEST = 'GET_CITIES_SENDING_REQUEST';
export const GET_CITIES_REQUEST_SUCCESS = 'GET_CITIES_REQUEST_SUCCESS';
export const GET_CITIES_REQUEST_FAILURE = 'GET_CITIES_REQUEST_FAILURE';
